import React from 'react';
import { FormattedNumber } from 'react-intl';

const FormattedValue = ({ value, minFractionDigits = 0 }) => (
  <FormattedNumber
    minimumFractionDigits={minFractionDigits}
    maximumFractionDigits={2}
    currencyDisplay="symbol"
    value={value}
    useGrouping
  />
);

export default FormattedValue;
